import { Outlet, createFileRoute, redirect } from "@tanstack/react-router"

import { PageLoading } from "@/components/page-loading"
import { PortalShell } from "@/components/portal-shell"
import { viewerQueryOptions } from "@/lib/query-options"

export const Route = createFileRoute("/admin")({
  beforeLoad: async ({ context }) => {
    const viewer =
      await context.queryClient.ensureQueryData(viewerQueryOptions())

    if (!viewer) {
      throw redirect({ to: "/login" })
    }

    if (viewer.role !== "admin") {
      throw redirect({ to: "/portal" })
    }

    return { viewer }
  },
  pendingComponent: PageLoading,
  head: () => ({
    meta: [{ title: "Operations console · Service Portal demo" }],
  }),
  component: AdminLayout,
})

function AdminLayout() {
  const { viewer } = Route.useRouteContext()

  return (
    <PortalShell viewer={viewer} mode="admin">
      <Outlet />
    </PortalShell>
  )
}
